<template>
    <div>
        <base-page-header :breadcrumb="breadcrumb" :title="entityName">
        </base-page-header>

        <v-row class="data-egars bg-white p-3 mb-10" v-if="!addItem">
            <v-col cols="12">
                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                        <div class="float-md-right mr-md-4 btn-add" @click="showNewItem"  v-bind="attrs" v-on="on">
                            <img src="/images/_SVGs/bo/adicionar.svg" onload="SVGInject(this)" class="circle" width="20" />
                        </div>
                    </template>
                    <span>{{$t('environmental-management.scheduling.new-appointment')}}</span>
                </v-tooltip>
            </v-col>
            <v-col cols="12">
                <SearchForm @on-search="onSearch" :actorsTypes="actorsTypes" :scheduling="true"/>
                <v-data-table
                    :headers="headers"
                    :items="egars"
                    :page="page"
                    :pageCount="numberOfPages"
                    :options.sync="options"
                    :server-items-length="totalRecords"
                    :footer-props="{
                        showFirstLastPage: true,
                        'items-per-page-options': [10, 20, 50]
                    }"
                >
                    <template v-slot:item.createDate="{ item }">
                        {{item.createDate | formatOnlyDate}}
                    </template>
                    <template v-slot:item.transportedResidue="{ item }">
                        <p class="title-table">{{item.transportedResidue? item.transportedResidue[0].designation : ''}}</p>
                        <p class="subTitle-table">{{item.transportedResidue? item.transportedResidue[0].groupCode : ''}} - {{item.transportedResidue? item.transportedResidue[0].lerDescription : ''}}</p>
                    </template>
                    <template v-slot:item.producer="{ item }">
                        <p class="title-table">{{item.producer.nif}} - {{item.producer.name}}</p>
                        <p class="subTitle-table">{{item.producer.apaCode}} - {{item.producer.name}}</p>
                    </template>
                    <template v-slot:item.qtd="{ item }">
                        {{item.transportedResidue? item.transportedResidue[0].quantity + ' Kg' : '-'}}
                    </template>
                    <template v-slot:item.status="{ item }">
                        <div :class="classStatus(item.status)">
                            <span v-html="getStatus(item.status)"></span>
                        </div>
                    </template>
                    <template v-slot:item.actions="{ item }">
                        <div class="menuEgar text-center" v-if="item.status == 1 || item.status == 2">
                            <v-menu>
                                <template v-slot:activator="{ on, attrs }">
                                    <span
                                        class="menu-egar"
                                        v-bind="attrs"
                                        v-on="on"
                                    >
                                    •••
                                    </span>
                                </template>

                                <v-list class="me-egar">
                                    <v-list-item @click="editEgar(item)">
                                        <v-list-item-title class="text-left">
                                            <span class="menu-action-egar">
                                                <img src="/images/_SVGs/environmental/edit_pencil.svg" alt="Editar" onload="SVGInject(this)" class="mr-1" width="30" height="30"/>
                                                {{$t('edit')}}
                                            </span>
                                        </v-list-item-title>
                                    </v-list-item>
                                    <v-list-item @click="cancelEgar(item)">
                                        <v-list-item-title class="text-left">
                                            <span class="menu-action-egar">
                                                <img src="/images/_SVGs/environmental/anular.svg" alt="Cancelado" onload="SVGInject(this)" class="mr-1" width="30" height="13"/>
                                                {{$t('cancel')}}
                                            </span>
                                        </v-list-item-title>
                                    </v-list-item>
                                </v-list>
                            </v-menu>
                        </div>
                    </template>
                </v-data-table>
            </v-col>
        </v-row>

        <v-form ref="form_scheduling" v-model="form.valide" v-else>
            <v-row class="bg-white p-3" >
                <v-col cols="12">
                    <base-button-back class="p-0" @click="cancelAddEgar()">{{$t('back')}}</base-button-back>
                </v-col>
                <v-col cols="12" sm="4">
                    <v-autocomplete
                        :items="actorsSenders.length > 0? actorsSenders.map(el => ({text: el.description,value: el})) : []"
                        v-model="selectActorsSenders"
                        filled
                        :rules="formInputs.default.rules"
                        hide-details="auto"
                        :label="$t('environmental-management.scheduling.intervenient-type-req')"
                    ></v-autocomplete>
                </v-col>
                <v-col cols="12" sm="4">
                    <v-autocomplete
                    :items="actorsSenderTypes.length > 0? actorsSenderTypes.map(el => ({text: el.description,value: el})) : []"
                    v-model="selectActorsSendersType"
                    filled
                    :rules="formInputs.default.rules"
                    hide-details="auto"
                    :label="$t('environmental-management.scheduling.profile-type-req')"
                    ></v-autocomplete>
                </v-col>

                <v-col cols="12">
                    <hr>
                </v-col>
                <v-col cols="12">
                    <h3>{{$t('environmental-management.scheduling.producer')}}</h3>
                </v-col>

                <v-col cols="12" sm="2">
                    <v-text-field
                    filled
                    v-model="form.producerEstablishment.nif"
                    @blur="getProducersEstablishmentNif()"
                    hide-details="auto"
                    :rules="formInputs.nif.rules"
                    :label="$t('environmental-management.scheduling.producer-nif')"
                    ></v-text-field>
                </v-col>
                <v-col cols="12" sm="2">
                    <v-select
                    v-model="form.producerType"
                    :items="producerType.length > 0? producerType.map(el => ({text: el.description,value: +el.producerTypeId})) : []"
                    :rules="formInputs.default.rules"
                    filled
                    hide-details="auto"
                    :label="$t('environmental-management.scheduling.type-req')"
                    :menu-props="{ top: false, offsetY: true }"
                    ></v-select>
                </v-col>
                <v-col cols="12" sm="5">
                    <v-select
                    v-model="selectProducerEstablishment"
                    :items="producersEstablishment.length > 0? producersEstablishment.map(el => ({text: el.name,value: el})) : []"
                    :rules="formInputs.default.rules"
                    filled
                    hide-details="auto"
                    :label="$t('environmental-management.scheduling.establishment-req')"
                    :menu-props="{ top: false, offsetY: true }"
                    ></v-select>
                </v-col>
                <v-col cols="12" sm="3" class="d-flex align-center">
                    <v-btn small  @click="obterProducer"> {{$t('environmental-management.scheduling.get-establishments')}} </v-btn>
                </v-col>

                <v-col cols="12" sm="4">
                    <v-text-field
                    v-model="form.producerEstablishment.address"
                    filled
                    :rules="formInputs.default.rules"
                    hide-details="auto"
                    readonly
                    :label="$t('environmental-management.scheduling.address-req')"
                    ></v-text-field>
                </v-col>
                <v-col cols="12" sm="4">
                    <v-text-field
                    v-model="form.producerEstablishment.postalCode"
                    filled
                    hide-details="auto"
                    :rules="formInputs.default.rules"
                    readonly
                    :label="$t('environmental-management.scheduling.postal-code-req')"
                    ></v-text-field>
                </v-col>
                <v-col cols="12" sm="4">
                    <v-text-field
                    v-model="form.producerEstablishment.locality"
                    filled
                    hide-details="auto"
                    :rules="formInputs.default.rules"
                    readonly
                    :label="$t('environmental-management.scheduling.locale-req')"
                    ></v-text-field>
                </v-col>


                <v-col cols="12">
                    <hr>
                </v-col>
                <v-col cols="12">
                    <h3>{{$t('environmental-management.scheduling.residue-operator')}}</h3>
                </v-col>

                <v-col cols="12" sm="4">
                    <v-combobox
                        clearable
                        filled
                        v-model="form.recipientEstablishment.nif"
                        :items="nifOGR"
                        :rules="formInputs.nif.rules"
                        hide-details="auto"
                        :label="$t('environmental-management.scheduling.nif-ogr-req')"
                        @change="getRecipientEstablishmentNif()"
                    ></v-combobox>
                </v-col>
                <v-col cols="12" sm="4">
                    <v-select
                        v-if="recipientsEstablishment.length > 0"
                        v-model="selectRecipientEstablishment"
                        :items="recipientsEstablishment.length > 0? recipientsEstablishment.map(el => ({text: el.name,value: el})) : []"
                        :rules="formInputs.default.rules"
                        filled
                        hide-details="auto"
                        :label="$t('environmental-management.scheduling.establishments')"
                        :menu-props="{ top: false, offsetY: true }"
                    ></v-select>
                </v-col>
                <v-col cols="12" sm="3" class="d-flex align-center">
                    <v-btn small v-if="recipientsEstablishment.length > 0" @click="obterRecipient"> {{$t('environmental-management.scheduling.get-establishments')}} </v-btn>
                </v-col>

                <v-col cols="12">
                    <hr>
                </v-col>
                <v-col cols="12">
                    <h3>{{$t('environmental-management.scheduling.residue')}}</h3>
                </v-col>
                <v-col cols="12" v-for="(residuo, index) in form.residuos" :key="index">
                    <v-row>
                        <v-col cols="12" sm="4">
                            <v-autocomplete
                                :items="lerCodes.length > 0? lerCodes.map(el => ({text: el.description, value: el.lerCodeId})) : []"
                                :rules="formInputs.default.rules"
                                filled
                                @change="getOperationCodes(residuo.lerCodeId, index, residuo)"
                                v-model="residuo.lerCodeId"
                                hide-details="auto"
                                :label="$t('environmental-management.scheduling.residue-designation')"
                            ></v-autocomplete>

                        </v-col>
                        <v-col cols="12" sm="3">
                            <v-text-field
                            v-model="residuo.codigoLer"
                            :rules="formInputs.default.rules"
                            filled
                            hide-details="auto"
                            :label="$t('environmental-management.scheduling.ler-code-req')"
                            readonly
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="2">
                            <v-autocomplete
                            :items="residuo.operations ? residuo.operations.map(el => ({text: el.operationCode,value: +el.operationCodeID})) : []"
                            v-model="residuo.operationCodeId"
                            @change="changeOperationCode(index)"
                            :rules="formInputs.default.rules"
                            filled
                            hide-details="auto"
                            :label="$t('environmental-management.scheduling.code-operator-req')"
                            ></v-autocomplete>
                        </v-col>
                        <v-col cols="12" sm="2">
                            <v-text-field
                            v-model="residuo.quantity"
                            :rules="formInputs.default.rules"
                            filled
                            hide-details="auto"
                            :label="$t('environmental-management.scheduling.qty')"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="2">
                          <v-autocomplete
                              :items="containerTypesItems"
                              v-model="residuo.containerTypeID"
                              :rules="formInputs.default.rules"
                              filled
                              hide-details="auto"
                              :label="$t('backoffice.environmental.containers.title')"
                            ></v-autocomplete>
                        </v-col>
                        <v-col cols="12" sm="2">
                          <v-text-field
                            v-model="residuo.containerQuantity"
                            :rules="formInputs.default.rules"
                            filled
                            hide-details="auto"
                            :label="$t('backoffice.environmental.containers.qty')"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="1" class="d-flex align-center justify-center">
                            <div class="btn-remove" @click="removeResiduo(index)" v-if="form.residuos.length > 1">
                                <img src="/images/_SVGs/bo/remove.svg" :alt="$t('environmental-management.scheduling.remove-item-alt')" onload="SVGInject(this)" class="circle" width="15" />
                            </div>
                        </v-col>
                    </v-row>
                </v-col>

                <v-col cols="12" sm="2">
                    <div class="btn-add" @click="addNewResiduo">
                        <img src="/images/_SVGs/bo/adicionar.svg" :alt="$t('environmental-management.scheduling.add-item-alt')" onload="SVGInject(this)" class="circle" width="15" />
                    </div>
                </v-col>

                <!--
                <v-col cols="12">
                    <hr>
                </v-col>
                <v-col cols="12">
                    <h3>Transporte de Resíduos Perigosos</h3>
                </v-col>

                <v-col cols="12">
                    <v-checkbox
                    label="Abrangido por ADR"
                    ></v-checkbox>
                </v-col>
                -->

                <v-col cols="12" class="mx-auto text-center">
                    <v-btn class="btn-primary-custom btn-red mr-md-3 mr-0 mb-3 mb-md-0" text @click="cancelAddEgar()">
                        {{$t('cancel')}}
                    </v-btn>
                    <v-btn rounded class="btn-primary-custom btn-grey mr-md-3 mr-0 mb-3 mb-md-0" @click="saveEgar(1)" :disabled="!form.valide">{{$t('save')}}</v-btn>
                    <v-btn rounded class="btn-primary-custom btn-grey mr-md-3 mr-0 mb-3 mb-md-0" @click="printEgarForm"
                           :disabled="!form.valideProducer">{{ $t('print') }}
                    </v-btn>
                    <v-btn rounded class="btn-primary-custom" @click="saveEgar(2)" :disabled="!form.valide">{{$t('send')}}</v-btn>
                </v-col>
            </v-row>
        </v-form>

        <!-- Modal Alerts. -->
        <base-modal v-model="modalAlert.show" modalAlign="align__flex--center" :title="modalAlert.title" modal-width="460px" :iconColor="modalAlert.iconColor" :iconName="modalAlert.iconName">
            <template v-slot:modal-close>
                <div @click="closeModalAlert()">
                    <img src="/images/_SVGs/environmental/fechar.svg" onload="SVGInject(this)" width="20" height="20" />
                </div>
            </template>

            <template v-slot:modal-body>
                {{modalAlert.message}}
            </template>

            <template v-slot:modal-actions>

                <div class="ml-2">
                    <v-btn text :class="modalAlert.iconColor == 'warning' ? 'danger-button' : 'primary-button'"  @click="closeModalAlert()">
                        <span style="text-transform: capitalize">{{$t('ok')}}</span>
                    </v-btn>
                </div>
            </template>
        </base-modal>

        <!-- Modal Cancel Egar. -->
        <base-modal v-model="modalCancelEgar.show" modalAlign="align__flex--center" :title="modalCancelEgar.title" modal-width="460px">
            <template v-slot:modal-close>
                <div @click="modalCancelEgar.show = false">
                    <img src="/images/_SVGs/environmental/fechar.svg" onload="SVGInject(this)" width="20" height="20" />
                </div>
            </template>

            <template v-slot:modal-body>
                {{modalCancelEgar.message}}
            </template>


            <template v-slot:modal-actions>
                <div class="mr-2">
                    <v-btn text class="danger-button"  @click="modalCancelEgar.show = false">
                        <span style="text-transform: capitalize">{{$t('no')}}</span>
                    </v-btn>
                </div>
                <div class="ml-2">
                    <v-btn text class="primary-button" @click="removeOrderEgar()">
                        <span style="text-transform: capitalize">{{$t('yes')}}</span>
                    </v-btn>
                </div>
            </template>
        </base-modal>
    </div>
</template>

<script>
import {
    GetEgars,
    GetEgarPreFilled,
    GetEstablishment,
    GetProducerTypes,
    GetLerCode,
    GetOperationCode,
    GetActorsSenders,
    PostOrderEgars,
    CancelOrderEgars,
    GetActorsTypes,
    PostPrintEgarForm
}
    from '@services/b2b/environmental-management/EgarService';
import { EnvironmentalDocServicesGetSILiAmbContainerTypes } from '@services/b2b/environmental-management/DocumentationService';
import { required, maxLength, minLength } from '@src/utils/validations.js';
import { debounce } from "lodash";
import BaseModal from "@components/shared/widgets/BaseModal.vue";
import BaseButtonBack from "@components/shared/widgets/BaseButtonBack.vue";
import BasePageHeader from "@components/shared/widgets/pages-header/BasePageHeader.vue";

    export default {
        components:{
            BasePageHeader,
            BaseButtonBack,
            BaseModal,
            SearchForm: () => import('@components/b2b/environmental-management/Scheduling/SearchForm')
        },
        data() {
          return{
              modalAlert: {
                  show: false,
                  title: '',
                  message: '',
                  iconName: '',
                  iconColor: '',
                  buttonRedirect: false,
              },
              nifOGR: null,
              modalCancelEgar: {
                  show: false,
                  title: '',
                  message: '',
              },
              breadcrumb: [
                  {
                      title: this.$t('environmental-management.title'),
                      routerLinkName: 'environmentalManagement'
                  },
                  {
                      title: this.$t('environmental-management.scheduling.entity-name')
                  }
              ],
              headers: [
              {
                  text: this.$t('environmental-management.scheduling.headers.request-date'),
                  align: 'start',
                  value: 'createDate',
              },
              { text: this.$t('environmental-management.scheduling.headers.residue'), value: 'transportedResidue' },
              { text: this.$t('environmental-management.scheduling.headers.qty'), value: 'qtd' },
              { text: this.$t('environmental-management.scheduling.headers.producer'), value: 'producer' },
              { text: this.$t('environmental-management.scheduling.headers.status'), value: 'status' },
              { text: '', value: 'actions' },
              ],
              page: 1,
              numberOfPages:1,
              options: {
                  page: 1,
                  itemsPerPage: 10
              },
              filters: [],
              itemsPerPage: 10,
              page: 1,
              totalRecords: 0,
              egars: [],
              addItem: false,
              items:[
                  'Item'
              ],
              lerCodes:[],
              operationCodes: [],
              entityName: this.$t('environmental-management.scheduling.entity-name'),
              nifNotFoundError: true,
              formInputs: {
                  default: {
                      rules: [required]
                  },
                  nif: {
                      rules: [required, minLength(9), maxLength(9), () => this.nifNotFoundError || this.$t('environmental-management.egar.new-egar-form.modal-alert.nif-not-found')]
                  },

              },
              form: {
                  codigoLer: null,
                  valide: false,
                  valideProducer: false,
                  producerType: 0,
                  producerEstablishment: {
                      nif: '',
                      name: '',
                      address: '',
                      postalCode: '',
                      locality: '',
                      apaCode: ''
                  },
                  recipientEstablishment: {
                      nif: "",
                      name: "",
                      address: "",
                      postalCode: "",
                      locality: "",
                      apaCode: ""
                  },
                  residuos: [{
                      designation: "",
                      lerCodeId: "",
                      operationCodeId: 0,
                      quantity: 0,
                      groupCode: "",
                      numberPgl: "",
                      operations: [],
                      containerTypeID: "",
                      containerQuantity: 0
                  }]
              },
              producersEstablishment: [],
              selectProducerEstablishment: [],
              producerType: [],
              recipientsEstablishment: [],
              selectRecipientEstablishment: null,
              actorsSenders: [],
              selectActorsSenders: [],
              actorsSenderTypes: [],
              selectActorsSendersType: null,
              selectLerCode: null,
              selectOperationCode: null,
              removerOrderEgarId: 0,
              isRefreshProducers: false,
              isRefreshRecipient: false,
              actorsTypes: [],
              tableFiltersOld: {},
              containerTypesItems: []
          }
        },
        computed: {
          userAuth() {
              return  this.$store.getters['auth/getState'];
          },
        },
        watch: {
            addItem: {
                handler: function(newValue, oldValue) {
                    if (newValue) {
                        if(!this.userAuth.isAdminSILiAmb){
                            this.getEgarPreFilled()
                        }else{
                            this.nifOGR = [this.userAuth.nif.substr(2)]
                            this.form.recipientEstablishment.nif = this.userAuth.nif.substr(2)
                        }

                        this.getTypeProducer()
                        this.getLerCodes()
                        this.getActorsSender()

                        this.getRecipientEstablishmentNif()
                    }
                },
                immediate: false,
                deep: true
            },
            selectProducerEstablishment: {
                handler: function(newValue, oldValue) {
                    if(newValue.apaCode){
                        this.form.producerEstablishment.apaCode= newValue.apaCode
                        this.form.producerEstablishment.authorizeIssuance= newValue.authorizeIssuance
                        this.form.producerEstablishment.address= newValue.headquartersAddress
                        this.form.producerEstablishment.locality= newValue.headquartersLocality
                        this.form.producerEstablishment.postalCode= newValue.headquartersPostalCode
                        this.form.producerEstablishment.name= newValue.name
                    }
                },
                immediate: false,
                deep: true
            },
            selectRecipientEstablishment: {
                handler: function(newValue, oldValue) {
                    if(newValue.apaCode){
                        this.form.recipientEstablishment.apaCode= newValue.apaCode
                        this.form.recipientEstablishment.authorizeIssuance= newValue.authorizeIssuance
                        this.form.recipientEstablishment.address= newValue.headquartersAddress
                        this.form.recipientEstablishment.locality= newValue.headquartersLocality
                        this.form.recipientEstablishment.postalCode= newValue.headquartersPostalCode
                        this.form.recipientEstablishment.name= newValue.name
                    }
                },
                immediate: false,
                deep: true
            },
            selectActorsSenders:{
                handler: function(newValue, oldValue) {
                    if(newValue.sendersType){
                        this.actorsSenderTypes = newValue.sendersType

                        this.selectActorsSendersType = newValue.sendersType[0]
                    }
                },
                immediate: false,
                deep: true
            },
            "options.page": {
                handler() {
                    this.filterPageTable(this.options);
                },
            },
            "options.itemsPerPage": {
                handler() {
                    this.filterPageTable(this.options);
                },
            },
            "options.sortBy": {
                handler() {
                    this.filterPageTable(this.options);
                },
                immediate: false,
            },
            form: {
                handler: function (newVal) {
                    this.checkProducerValidity();
                },
                deep: true
            },
            deep: true,
        },
        methods:{
            filterPageTable(event){
                this.itemsPerPage = event.itemsPerPage

                let sort = "";
                if (event.sortDesc[0] == true) {
                    sort = "DESC";
                } else if (event.sortDesc[0] == false) {
                    sort = "ASC";
                }

                Object.assign(this.filters, {
                        pageSize: event.itemsPerPage,
                        currentPage: event.page
                    }
                )

                if (event.sortBy.length > 0) {
                    Object.assign(this.filters, {
                        orderField: event.sortBy[0] ? event.sortBy[0] : "",
                        orderBy: sort,
                    });
                }

                this.getAllEGAR()
            },
            onSearch(event) {
                Object.assign(this.filters, {
                    searchText: event.searchText,
                    statusIds: event.status,
                    createDateTo: event.createDateTo,
                    createDateFrom: event.createDateFrom,
                    isUpdate: false,
                });

                this.getAllEGAR()
            },
            editEgar(item){
                this.$router.push({ name: 'environmentalManagementSchedulingEdit', params: { id: item.egarId }})
            },
            cancelEgar(item){
                this.removerOrderEgarId = item.egarId
                this.modalCancelEgar.title = this.$t('heads-up');
                this.modalCancelEgar.message = this.$t('environmental-management.scheduling.modal-cancel.msg');
                this.modalCancelEgar.show = true;
            },
            removeOrderEgar(){
                this.modalCancelEgar.show = false;
                if(this.removerOrderEgarId > 0){
                    this.$store.commit('loadings/setStateLoadingTemplate', true);

                    return CancelOrderEgars(this.removerOrderEgarId)
                        .then(response => {
                            this.egars = this.egars.filter(el => el.egarId != this.removerOrderEgarId)

                            this.getAllEGAR();

                            this.modalAlert.message = this.$t('environmental-management.scheduling.modal-alert.msg1');
                            this.modalAlert.title = this.$t('environmental-management.scheduling.modal-alert.title1');
                            this.modalAlert.iconName = 'mdi-shield-check';
                            this.modalAlert.iconColor = 'success';
                            this.modalAlert.show = true;
                        })
                        .catch(error => {
                            this.$requestStatus.checkRequestStatus(error.response.status, this.$route.name);
                            this.modalAlert.message = this.$t('environmental-management.scheduling.modal-alert.msg2');
                            this.modalAlert.title = this.$t('heads-up');
                            this.modalAlert.iconName = 'mdi-alert-outline';
                            this.modalAlert.iconColor = 'warning';
                            this.modalAlert.show = true;
                            throw new Error('error to modalCancelEgar values', error);
                        })
                        .finally(() => {
                            this.$store.commit('loadings/setStateLoadingTemplate', false);
                        })
                }

            },
            getStatus(item){
                switch (item) {
                    case '1':
                        return `<img src="/images/_SVGs/environmental/pendente.svg" alt="${this.$t('environmental-management.scheduling.status.recorded')}" onload="SVGInject(this)" class="mr-5" width="20" height="20"/> ${this.$t('environmental-management.scheduling.status.recorded')}`
                    case '2':
                        return `<img src="/images/_SVGs/environmental/pendente.svg" alt="${this.$t('environmental-management.scheduling.status.collection-request')}" onload="SVGInject(this)" class="mr-5" width="20" height="20"/> ${this.$t('environmental-management.scheduling.status.collection-request')}`
                    case '3':
                        return `<img src="/images/_SVGs/environmental/road.svg" alt="${this.$t('environmental-management.scheduling.status.on-route')}" onload="SVGInject(this)" class="mr-5" width="20" height="20"/> ${this.$t('environmental-management.scheduling.status.on-route')}`
                    case '4':
                        return `<img src="/images/_SVGs/environmental/check.svg" alt="${this.$t('environmental-management.scheduling.status.finished')}" onload="SVGInject(this)" class="mr-5" width="20" height="20"/> ${this.$t('environmental-management.scheduling.status.finished')}`
                    case '5':
                        return `<img src="/images/_SVGs/close.svg" alt="${this.$t('environmental-management.scheduling.status.canceled')}" onload="SVGInject(this)" class="mr-5" width="20" height="20"/> ${this.$t('environmental-management.scheduling.status.canceled')}`
                    case '6':
                        return `<img src="/images/_SVGs/close.svg" alt="${this.$t('environmental-management.scheduling.status.not-collected')}" onload="SVGInject(this)" class="mr-5" width="20" height="20"/> ${this.$t('environmental-management.scheduling.status.not-collected')}`
                    default:
                        return '-'
                }
            },
            changeOperationCode(index){
                if(this.form.residuos[index].operationCodeId){
                    this.operationCodes.map(el =>
                    {
                        if(el.operationCodeID == this.form.residuos[index].operationCodeId){
                            this.form.residuos[index].groupCode = el.operationCode
                            this.form.residuos[index].operationCode = el.operationCode
                            this.form.residuos[index].numberPgl = el.averageWeight
                        }

                    })
                }
            },
            closeModalAlert(){
                this.$store.commit('loadings/setStateLoadingTemplate', true);

                this.modalAlert.message = '';
                this.modalAlert.title = '';
                this.modalAlert.iconName = '';
                this.modalAlert.iconColor = '';
                this.modalAlert.show = false;

                if(this.modalAlert.buttonRedirect){
                    this.modalAlert.buttonRedirect = false;
                    this.cancelAddEgar();
                    this.getAllEGAR();
                }
                this.modalCancelEgar.show = false
                this.$store.commit('loadings/setStateLoadingTemplate', false);
                this.form.recipientEstablishment.nif = ''


            },
            cancelAddEgar(){
                this.addItem = false;
                this.form = {
                    valide: false,
                    producerType: 0,
                    producerEstablishment: {
                        nif: '',
                        name: '',
                        address: '',
                        postalCode: '',
                        locality: '',
                        apaCode: ''
                    },
                    recipientEstablishment: [{
                        nif: "",
                        name: "",
                        address: "",
                        postalCode: "",
                        locality: "",
                        apaCode: ""
                    }],
                    residuos: [{
                        designation: "",
                        lerCodeId: "",
                        operationCodeId: 0,
                        quantity: 0,
                        groupCode: "",
                        numberPgl: ""
                    }]
                }
                this.selectProducerEstablishment = ""
                this.selectRecipientEstablishment = ""
                this.recipientsEstablishment = []
            },
            classStatus(status){
                if(status == "1" || status == "2"){
                    return 'pendent';
                } else if(status == '3'){
                    return 'in-route'
                }  else if(status == '4'){
                    return 'complete'
                }  else if(status == '5' || status == '6'){
                    return 'cancel'
                }
            },
            showNewItem(){
                this.addItem = true
            },
            addNewResiduo(){
                this.form.residuos.push({
                    designation: "",
                    lerCodeId: "",
                    operationCodeId: 0,
                    quantity: 0,
                    groupCode: "",
                    numberPgl: "",
                    operations: [],
                })
            },
            removeResiduo(index){
                this.form.residuos.splice(index, 1);
            },
            getAllEGAR: debounce(function(){
                this.$store.commit('loadings/setStateLoadingTemplate', true);
                // Object.assign(this.filters, {
                //         statusIds: [1, 2, 3, 4]
                //     }
                // )
                return GetEgars(this.filters)
                    .then(response => {
                        if(response.data.result){
                            this.totalRecords = response.data.totalRecords
                            this.egars = response.data.result
                        } else {
                            this.totalRecords = 0
                            this.egars = []
                        }
                    })
                    .catch(error => {
                        this.$requestStatus.checkRequestStatus(error.response.status, this.$route.name);
                        throw new Error('error to get list egar values', error);
                    })
                    .finally(() => {
                        this.$store.commit('loadings/setStateLoadingTemplate', false);
                    })
            }, 100),
            getEgarPreFilled(){
                this.$store.commit('loadings/setStateLoadingTemplate', true);

                return GetEgarPreFilled()
                    .then(response => {
                        this.form.producerEstablishment.nif = response.data.result.producerNif
                        this.producersEstablishment = response.data.result.producerEstablishments.map(el => {
                            return {
                                apaCode: el.apaCode,
                                authorizeIssuance: true,
                                headquartersAddress: el.fullName,
                                headquartersLocality: el.locality,
                                headquartersPostalCode: el.postalCode,
                                name: el.name,
                                nif: response.data.result.producerNif,
                            }
                        })
                        this.recipientsEstablishment = response.data.result.recipientEstablishments.map(el => {
                            return {
                                apaCode: el.apaCode,
                                authorizeIssuance: true,
                                headquartersAddress: el.fullName,
                                headquartersLocality: el.locality,
                                headquartersPostalCode: el.postalCode,
                                name: el.name,
                                nif: response.data.result.recipientNif,
                            }
                        })

                        this.selectRecipientEstablishment = this.recipientsEstablishment[0]
                        this.form.recipientEstablishment.nif = response.data.result.recipientNif

                        this.nifOGR = [response.data.result.recipientNif]
                    })
                    .catch(error => {
                        if(error.response.status == this.$globals.ERROR_CODES.CONFLICT) {
                            if(this.$refs.form_scheduling) {
                                this.nifNotFoundError = false;
                                this.$refs.form_scheduling.validate();
                            }
                        }
                    })
                    .finally(() => {
                        this.$store.commit('loadings/setStateLoadingTemplate', false);
                        this.getProducersEstablishmentNif()
                    })
            },
            obterProducer(){
                this.isRefreshProducers = true;
                this.getProducersEstablishmentNif()
            },
            getProducersEstablishmentNif(){
                this.nifNotFoundError = true;
                if(this.$refs.form_scheduling) {
                    this.$refs.form_scheduling.validate();
                }
                this.selectProducerEstablishment = [];
                this.form.producerEstablishment.name = ''
                this.form.producerEstablishment.address = ''
                this.form.producerEstablishment.postalCode = ''
                this.form.producerEstablishment.locality = ''
                this.form.producerEstablishment.apaCode = ''

                let filter = {
                    nif: null,
                    isRefresh: this.isRefreshProducers
                };
                if(this.form.producerEstablishment.nif){
                    if(this.form.producerEstablishment.nif.length < 9){
                        return
                    }
                    filter = {
                        nif: this.form.producerEstablishment.nif,
                        isRefresh: this.isRefreshProducers
                    }
                }

                if(filter.nif){
                    this.$store.commit('loadings/setStateLoadingTemplate', true);

                    return GetEstablishment(filter)
                        .then(response => {
                            if(response.data.result.length > 0){
                                this.producersEstablishment = response.data.result

                                this.form.producerType = this.producerType[0].producerTypeId

                                this.selectProducerEstablishment = this.producersEstablishment[0]
                            }else{
                                this.nifNotFoundError = false;
                                if(this.$refs.form_scheduling) {
                                    this.$refs.form_scheduling.validate();
                                }
                                this.modalAlert.message = this.$t('environmental-management.scheduling.modal-alert.msg3');
                                this.modalAlert.title = this.$t('heads-up');
                                this.modalAlert.iconName = 'mdi-alert-outline';
                                this.modalAlert.iconColor = 'warning';
                                this.modalAlert.show = true;
                            }
                        })
                        .catch(error => {
                            if(error.response.status == this.$globals.ERROR_CODES.CONFLICT) {
                                if(this.$refs.form_scheduling) {
                                    this.nifNotFoundError = false;
                                    this.$refs.form_scheduling.validate();
                                }
                            }
                        })
                        .finally(() => {
                            this.isRefreshProducers = false
                            this.$store.commit('loadings/setStateLoadingTemplate', false);
                            this.checkProducerValidity();
                        })
                }
                return
            },
            obterRecipient(){
                this.isRefreshRecipient = true;
                this.getRecipientEstablishmentNif()
            },
            getRecipientEstablishmentNif(){
                this.nifNotFoundError = true;
                if(this.$refs.form_scheduling) {
                    this.$refs.form_scheduling.validate();
                }
                this.selectRecipientEstablishment = [];
                this.form.recipientEstablishment.name = ''
                this.form.recipientEstablishment.address = ''
                this.form.recipientEstablishment.postalCode = ''
                this.form.recipientEstablishment.locality = ''
                this.form.recipientEstablishment.apaCode = ''
                this.recipientsEstablishment = []

                let filter = {
                    nif: null,
                    isRefresh: this.isRefreshRecipient
                };
                if(this.form.recipientEstablishment.nif){
                    if(this.form.recipientEstablishment.nif.length < 9){
                        return
                    }
                    filter = {
                        nif: this.form.recipientEstablishment.nif,
                        isRefresh: this.isRefreshRecipient
                    }
                }

                if(filter.nif){
                    this.$store.commit('loadings/setStateLoadingTemplate', true);

                    return GetEstablishment(filter)
                        .then(response => {
                            if(response.data.result.length > 0){
                                this.recipientsEstablishment = response.data.result
                                this.selectRecipientEstablishment = response.data.result[0]
                            }else{
                                this.form.recipientEstablishment.nif = ''
                                this.modalAlert.message = this.$t('environmental-management.scheduling.modal-alert.msg4');
                                this.modalAlert.title = this.$t('heads-up');
                                this.modalAlert.iconName = 'mdi-alert-outline';
                                this.modalAlert.iconColor = 'warning';
                                this.modalAlert.show = true;
                            }
                        })
                        .catch(error => {
                            this.$requestStatus.checkRequestStatus(error.response.status, this.$route.name);

                            this.form.recipientEstablishment.nif = ''
                            this.modalAlert.message = this.$t('environmental-management.scheduling.modal-alert.msg4');
                            this.modalAlert.title = this.$t('heads-up');
                            this.modalAlert.iconName = 'mdi-alert-outline';
                            this.modalAlert.iconColor = 'warning';
                            this.modalAlert.show = true;
                            this.form.recipientEstablishment.nif = ''
                            throw new Error('error to get GetEstablishment egar values', error);
                        })
                        .finally(() => {
                            this.isRefreshRecipient = false;
                            this.$store.commit('loadings/setStateLoadingTemplate', false);
                            this.checkProducerValidity();
                        })
                }
                return
            },
            getTypeProducer(){
                if(this.producerType.length == 0){
                    this.$store.commit('loadings/setStateLoadingTemplate', true);

                    return GetProducerTypes()
                        .then(response => {
                            this.producerType = response.data.result
                        })
                        .catch(error => {
                            this.$requestStatus.checkRequestStatus(error.response.status, this.$route.name);
                            throw new Error('error to get GetProducerTypes egar values', error);
                        })
                        .finally(() => {
                            this.$store.commit('loadings/setStateLoadingTemplate', false);
                        })
                }
            },
            getLerCodes(){
                if(this.lerCodes.length == 0){
                    this.$store.commit('loadings/setStateLoadingTemplate', true);

                    return GetLerCode()
                        .then(response => {
                            this.lerCodes = response.data.result
                        })
                        .catch(error => {
                            this.$requestStatus.checkRequestStatus(error.response.status, this.$route.name);
                            throw new Error('error to get GetLerCode values', error);
                        })
                        .finally(() => {
                            this.$store.commit('loadings/setStateLoadingTemplate', false);
                        })
                }
            },
            getOperationCodes(lerCode, index, residuo){
                this.$store.commit('loadings/setStateLoadingTemplate', true);
                const lerCodes = _.cloneDeep(this.lerCodes)
                residuo.codigoLer = lerCodes.filter(el => el.lerCodeId == residuo.lerCodeId)[0].lerCode
                residuo.designation = lerCodes.filter(el => el.lerCodeId == residuo.lerCodeId)[0].description
                return GetOperationCode(lerCode)
                    .then(response => {
                        if(response.data.result.length > 0){
                            this.form.residuos[index].operations = response.data.result
                            residuo.operationCodeId = response.data.result ? response.data.result[0].operationCodeID : null;

                            const findR12 = response.data.result.filter(elem => elem.operationCode == 'R12');
                            if(findR12 && findR12.length > 0) {
                                residuo.operationCodeId = findR12[0].operationCodeID;
                            }
                        }
                    })
                    .catch(error => {
                        this.$requestStatus.checkRequestStatus(error.response.status, this.$route.name);
                        throw new Error('error to get GetLerCode values', error);
                    })
                    .finally(() => {
                        this.$store.commit('loadings/setStateLoadingTemplate', false);
                    })

            },
            getActorsSender(){
                if(this.actorsSenders.length == 0){
                    this.$store.commit('loadings/setStateLoadingTemplate', true);

                    return GetActorsSenders()
                        .then(response => {
                            if(response.data.result.length > 0){
                                this.actorsSenders = response.data.result
                                if(!this.userAuth.isAdminSILiAmb){
                                    this.selectActorsSenders = this.actorsSenders.filter(el => el.code == 'P')[0]
                                }else{
                                    this.selectActorsSenders = this.actorsSenders.filter(el => el.code == 'D')[0]
                                }
                            }
                        })
                        .catch(error => {
                            this.$requestStatus.checkRequestStatus(error.response.status, this.$route.name);
                            throw new Error('error to get GetActorsSenders values', error);
                        })
                        .finally(() => {
                            this.$store.commit('loadings/setStateLoadingTemplate', false);
                        })
                }

            },
            saveEgar(status) {
                this.$store.commit('loadings/setStateLoadingTemplate', true);

                if(this.form.producerEstablishment.apaCode == this.form.recipientEstablishment.apaCode){

                    this.modalAlert.message = this.$t('environmental-management.scheduling.modal-alert.msg5');
                    this.modalAlert.title = this.$t('heads-up');
                    this.modalAlert.iconName = 'mdi-alert-outline';
                    this.modalAlert.iconColor = 'warning';
                    this.modalAlert.show = true;
                    this.$store.commit('loadings/setStateLoadingTemplate', false);

                    return
                }
                let body = {
                    producerNif: this.form.producerEstablishment.nif,
                    actorTypeId: this.selectActorsSenders.actorTypeID,
                    producerTypeId: this.form.producerType,
                    senderTypeId: this.selectActorsSendersType.senderTypeID,
                    recipientNif: this.form.recipientEstablishment.nif,
                    statusId: status,
                    producerEstablishment: {
                        name: this.form.producerEstablishment.name,
                        address: this.form.producerEstablishment.address,
                        postalCode: this.form.producerEstablishment.postalCode,
                        locality: this.form.producerEstablishment.locality,
                        apaCode: this.form.producerEstablishment.apaCode
                    },
                    recipientEstablishment: {
                        name: this.form.recipientEstablishment.name,
                        address: this.form.recipientEstablishment.address,
                        postalCode: this.form.recipientEstablishment.postalCode,
                        locality: this.form.recipientEstablishment.locality,
                        apaCode: this.form.recipientEstablishment.apaCode
                    },
                    residues: this.form.residuos
                }

                return PostOrderEgars(body)
                .then(response => {
                    this.modalAlert.message = this.$t('environmental-management.scheduling.modal-alert.msg6');
                    this.modalAlert.title = this.$t('environmental-management.scheduling.modal-alert.title2');
                    this.modalAlert.iconName = 'mdi-shield-check';
                    this.modalAlert.iconColor = 'success';
                    this.modalAlert.show = true;
                    this.modalAlert.buttonRedirect = true
                })
                .catch(error => {
                    this.$requestStatus.checkRequestStatus(error.response.status, this.$route.name);

                    this.modalAlert.message = this.$t('environmental-management.scheduling.modal-alert.msg7');
                    this.modalAlert.title = this.$t('heads-up');
                    this.modalAlert.iconName = 'mdi-alert-outline';
                    this.modalAlert.iconColor = 'warning';
                    this.modalAlert.show = true;
                    throw new Error('error to get GetActorsSenders values', error);
                })
                .finally(() => {
                    this.$store.commit('loadings/setStateLoadingTemplate', false);
                })
            },
            getActors_Types(){
                this.$store.commit('loadings/setStateLoadingTemplate', true);

                return GetActorsTypes()
                    .then(response => {
                            this.actorsTypes = response.data.result
                            this.selectActorsSenders = 1
                    })
                    .catch(error => {
                        this.$requestStatus.checkRequestStatus(error.response.status, this.$route.name);
                        throw new Error('error to get GetActorsSenders values', error);
                    })
                    .finally(() => {
                        this.$store.commit('loadings/setStateLoadingTemplate', false);
                    })
            },
            async getSILiAmbContainerTypes() {
              this.$store.commit('loadings/setStateLoadingTemplate', true);
              await EnvironmentalDocServicesGetSILiAmbContainerTypes()
                .then(response => {
                  if(response.data.result) {
                    response.data.result.forEach(recipe => {
                      let newRecipe = {
                        ...recipe,
                        text: recipe.description,
                        value: recipe.containerTypeId
                      }
                      this.containerTypesItems.push(newRecipe);
                    })
                  } else {
                    this.containerTypesItems = [];
                  }
                })
                .catch(error => {
                    this.$requestStatus.checkRequestStatus(error.response.status, this.$route.name);
                    throw new Error('error EnvironmentalDocServicesGetSILiAmbContainerTypes', error);
                })
                .finally(() => {
                    this.$store.commit('loadings/setStateLoadingTemplate', false);
                })
            },
            async printEgarForm() {
                this.$store.commit('loadings/setStateLoadingTemplate', true);
                const filledResidues = this.form.residuos.filter(residue =>
                    residue.designation || residue.codigoLer || residue.quantity || residue.containerTypeID || residue.containerQuantity
                ).map(residue => {
                    const containerType = this.containerTypesItems.find(item => item.value === residue.containerTypeID);
                    return {
                        designation: residue.designation || "",
                        lerCode: residue.codigoLer || "",
                        quantity: residue.quantity === 0 ? "" : residue.quantity.toString(),
                        containerType: containerType ? containerType.text : null,
                        containerQuantity: residue.containerQuantity === 0 ? "" : residue.containerQuantity.toString()
                    };
                });

                const emptyRows = Array(filledResidues.length > 0 ? 0 : 16).fill({
                    designation: "",
                    lerCode: "",
                    quantity: "",
                    containerType: null,
                    containerQuantity: ""
                });

                let data = {
                    nif: this.form.producerEstablishment.nif,
                    name: this.form.producerEstablishment.name,
                    address: this.form.producerEstablishment.address,
                    postalCode: this.form.producerEstablishment.postalCode,
                    locality: this.form.producerEstablishment.locality,
                    createdDate: `${new Date().getDate()}/${new Date().getMonth() + 1}/${new Date().getFullYear()}`,
                    residue: [...filledResidues, ...emptyRows]
                };

                return PostPrintEgarForm(data)
                    .then(response => {
                        const blob = new Blob([response.data], {type: 'application/pdf'});
                        const link = document.createElement('a');
                        link.href = URL.createObjectURL(blob);
                        window.open(link);
                    })
                    .catch(error => {
                        console.error('Error downloading EGAR form:', error);
                    })
                    .finally(() => {
                        this.$store.commit('loadings/setStateLoadingTemplate', false);
                    });
            },
            checkProducerValidity() {
                const {
                    producerType,
                    producerEstablishment,
                    recipientEstablishment
                } = this.form;

                const isProducerValid =
                    producerType !== 0 &&
                    producerEstablishment.nif !== '' &&
                    producerEstablishment.name !== '' &&
                    producerEstablishment.address !== '' &&
                    producerEstablishment.postalCode !== '' &&
                    producerEstablishment.locality !== '' &&
                    producerEstablishment.apaCode !== '';

                const isRecipientValid =
                    recipientEstablishment.nif !== '' &&
                    recipientEstablishment.name !== '' &&
                    recipientEstablishment.address !== '' &&
                    recipientEstablishment.postalCode !== '' &&
                    recipientEstablishment.locality !== '' &&
                    recipientEstablishment.apaCode !== '';

                const isActorsSendersValid =
                    this.selectActorsSenders !== null &&
                    this.selectActorsSendersType !== null;

                this.form.valideProducer = isProducerValid && isRecipientValid && isActorsSendersValid;
            },
        },
        async mounted() {
            Object.assign(this.filters, {
                    statusIds: [1, 2, 3, 4]
                }
            )
            this.getSILiAmbContainerTypes();
            this.getAllEGAR();
            this.entityName = this.$t('environmental-management.scheduling.entity-name');
            this.getActors_Types();
        }
    }
</script>

<style lang="scss" scoped>
@import '@sass/_variables.scss';


::v-deep table{
    thead {

        th{
            font-size: 13px !important;
            border: 0px solid rgb(224 224 224);
            height: 30px !important;
            background: $grey-light;
            color:rgb(113 113 113 / 60%) !important;
        }
    }
    tbody{
        td{
            border: 0px solid rgb(224 224 224);
            font-size: 13px !important;
            p{
                margin-bottom: 0;
                &.subTitle-table{
                    margin-top: 3px;
                    color: #c5c2c2;
                }
            }
        }
    }
}

.btn-add{
    cursor: pointer;
    .circle{
        background: var(--v-primary-base);
        width: 40px;

        ::v-deep path{
            fill: #ffffff !important;
        }
    }
    &:hover{
        .circle{
            background: var(--v-primary-lighten3);
        }
    }
}
.btn-remove{
    cursor: pointer;
    .circle{
        background: var(--v-error-base);
        width: 40px;

        ::v-deep path{
            fill: #ffffff !important;
        }
    }
    &:hover{
        .circle{
            background: var(--v-error-lighten3);
        }
    }
}

.btn-grey{
    background: $grey;
}

.btn-red{
    border-radius: 28px;
    background: $red;
}

.pendent{
    opacity: 0.3;
}
.complete{
    color:#4CAA5E;
    ::v-deep svg{
        path{
            fill: #4CAA5E;
        }
    }
}
.cancel{
    color:#D90B3B;
    ::v-deep svg{
        path:nth-last-child(1){
            fill: #D90B3B;
        }
    }
}
.menu-egar{
    color:var(--v-primary-base);
}

.me-egar{
    z-index: 100;
    ::v-deep .v-list-item{
        min-width: 130px;
        max-width: 130px;

        .menu-action-egar{
            cursor: pointer;
            color:#9E9D9D;
            font-size: 12px;
            letter-spacing: 0.16px;
            svg{
                path{
                    fill: #9E9D9D;
                }
            }
        }
        &:hover{
            background: var(--v-primary-base);
            svg{
                path{
                    fill: #fff;
                }
            }
            .menu-action-egar{
                color:#fff;
            }
        }
    }
}
</style>
